import { Component, Input } from '@angular/core';

@Component({
  selector   : 'wor-footer',
  styles: [ require('./footer.component.scss') ],
  template: require('./footer.component.html')
})
export class FooterComponent {
  @Input() showRecaptcha : boolean;
}
